import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, pluck, switchMap, tap } from 'rxjs/operators';
import { ScSearchConfig } from '../../../../models/generic-form.model';
import { RestService } from '../../../../services/rest-service.service';

@Component({
  selector: 'sc-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit {
  @Input() placeholder: string;
  @Input() config: ScSearchConfig;
  @Input() public disabled: boolean;
  @Input() uppercase: boolean;

  @Output() selected: EventEmitter<any> = new EventEmitter();

  public filteredEntities: Observable<any[]>;
  public formControl: FormControl = new FormControl('');

  private _appearance: MatFormFieldAppearance = 'standard';

  constructor(private _restService: RestService) {}
  @Input() public set value(value: string) {
    this.writeValue(value);
  }

  @Input() set appearance(appearance: MatFormFieldAppearance) {
    if (appearance) {
      this._appearance = appearance;
    }
  }

  get appearance(): MatFormFieldAppearance {
    return this._appearance;
  }

  onChange = (regno: string) => {};
  onTouched = () => {};

  public ngOnInit() {
    if (!this.config) {
      console.warn('AbleraSearchConfig is missing!');
      return;
    }
    const { filterBy, endpoint, filters } = this.config;
    this.filteredEntities = this.formControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => {
        const isString = typeof value === 'string';
        if (!isString && value && value[filterBy]) {
          this.writeValue(value);
        }

        return isString;
      }),
      switchMap((value: string) =>
        this._restService
          .post<any[]>(endpoint, {
            filters: [
              {
                prop: filterBy,
                comparison: 'contains',
                value: this.uppercase ? value.toUpperCase() : value
              },
              ...filters
            ]
          })
          .pipe(pluck('items'))
      ),
      tap((values: any[]) => {
        if (values.length === 1 && !this.formControl.dirty) {
          this.formControl.setValue(values[0]);
        }
      })
    );
  }

  public displayFn(data: any) {
    return data && data[this.config.filterBy];
  }

  writeValue(value: any) {
    setTimeout(() => {
      this.formControl.setValue(value);
      this.selected.emit(value);
      this.onChange(value);
    }, 10);
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
